module.exports = __webpack_public_path__ + "img/Elche.48aef0f1.png";